export class $Event<T=any> {
  constructor( public $event: T = null ) {
  }
}



// WEBPACK FOOTER //
// ./app/helpers/$event.ts